import type {
  CoreApiResponseList,
  CoreItemCalendar,
  CoreItemListMeta,
} from '@flecto/types'

import { api } from '../../../services/api'
import { deserialize } from '../../../services/deserialize'

/**
 * Checks items availability.
 *
 * @endpoint GET /api/saas/me/products/calendar
 * @scope saas
 * @see https://flecto.dev/api-4724229
 */
export async function getAllItemsCalendar(
  options: GetAllItemsCalendarOptions = { offset: 0, limit: 10000 }
): Promise<CoreApiResponseList<CoreItemCalendar[], CoreItemListMeta>> {
  const response = await api.get('/api/saas/me/products/calendar', {
    params: options,
  })
  const { data, meta } = deserialize<CoreItemCalendar[]>(response.data)

  return { data, meta }
}

export type GetAllItemsCalendarOptions = {
  q?: string
  limit?: number
  offset?: number
  start_at?: string
  end_at?: string
  ignore_booking_ids?: number[]
}
